/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as DraftDefs from './defs.defs.js'

const $nsid = 'app.bsky.draft.createDraft'

export { $nsid }

/** Inserts a draft using private storage (stash). An upper limit of drafts might be enforced. Requires authentication. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    draft: l.ref<DraftDefs.Draft>((() => DraftDefs.draft) as any),
  }),
  l.jsonPayload({ id: l.string() }),
  ['DraftLimitReached'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
